export default "__VITE_ASSET__DiFynmXG__"